import React from 'react'
import { useStyles } from './styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { ValueScale, ArgumentScale } from '@devexpress/dx-react-chart'
import { scaleBand } from '@devexpress/dx-chart-core'
import { ArgumentAxis, ValueAxis, Chart, BarSeries, Title } from '@devexpress/dx-react-chart-material-ui'
import TitleText from './components/TitleText'
import ValueAxisLegend from './components/ValueAxisLegend'
import ArgumentAxisLegend from './components/ArgumentAxisLegend'
import { ENGAGEMENT_QUARTILE_GRAPH_ROOT_CONTAINER_ID } from '../../../../utils/graphUtils'
import Bar from './components/Bar'
import Export from './components/Export'
import Period from './components/Period'

const EngagementQuartileGraph = ({ data: { learners }, selectedWave }) => {
  const classes = useStyles()
  const chartData = Object.keys(learners.progress.engagementByQuartile).map((entry, idx) => ({
    inactiveUsers: learners.progress.engagementByQuartile[entry].inactiveUsersCount,
    q: learners.progress.engagementByQuartile[entry].daysPerStep,
    offset: idx
  }))

  const quartileWithInactiveUsers = chartData.findIndex(el => el.inactiveUsers > 0)
  const inactiveUsers = chartData[quartileWithInactiveUsers] ? chartData[quartileWithInactiveUsers].inactiveUsers : 0
  const daysPerStep = chartData[quartileWithInactiveUsers] ? chartData[quartileWithInactiveUsers].q : 0

  return (
    <Paper className={classes.chartBackground} id={ENGAGEMENT_QUARTILE_GRAPH_ROOT_CONTAINER_ID}>
      <Chart data={chartData.reverse()} className={classes.chart} rotated={true}>
        <ArgumentAxis
          showTicks={false}
          indentFromAxis={16}
          labelComponent={props => {
            return (
              <ArgumentAxis.Label
                {...props}
                x={quartileWithInactiveUsers === props.text && daysPerStep ? props.x + 8 : props.x}
                style={{
                  fill: '#000000',
                  fontFamily: 'National',
                  fontSize: '13px'
                }}
                text={`Q${props.text + 1}${quartileWithInactiveUsers === props.text && daysPerStep ? '*' : ''}`.toUpperCase()}
              />
            )
          }}
        />
        <ArgumentScale factory={scaleBand} />
        <ValueScale modifyDomain={([min, max]) => [min, max * 1.25]} />
        <Title text='Days Per Step by Engagement Quartile' textComponent={TitleText} />
        <ValueAxis showGrid={false} showLine={true} tickFormat={() => tick => (Number.isInteger(tick) ? tick : null)} />
        <BarSeries rotated={true} valueField='q' argumentField='offset' barWidth={0.7} pointComponent={Bar} />
        <ValueAxisLegend />
        <ArgumentAxisLegend />
        {selectedWave && <Period selectedWave={selectedWave} />}
        <Export />
      </Chart>
      {quartileWithInactiveUsers !== -1 && daysPerStep ? (
        <Typography variant='h5' component='div' className={classes.legend}>
          {`*Ignores learners who made no recent progress (Q${quartileWithInactiveUsers + 1}:${inactiveUsers})`}
        </Typography>
      ) : null}
    </Paper>
  )
}

export default EngagementQuartileGraph
